import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCZECcDK5lVeUegsjEOebIR2SVohH3-rI4",
  // authDomain: "sbgonlinestore-2020.firebaseapp.com",
  authDomain: "auth.biblias.gt",
  databaseURL: "https://sbgonlinestore-2020.firebaseio.com",
  projectId: "sbgonlinestore-2020",
  storageBucket: "bibliasgt",
  messagingSenderId: "14738606269",
  appId: "1:14738606269:web:9135451d5d07b20b394fd4",
  measurementId: "G-8NZS1PXT0Y"
};

firebase.initializeApp(firebaseConfig);

// firebase utils
const db = firebase.firestore();

// Fuerza long-polling en lugar de WebChannel/streaming para las conexiones de
// Firestore. Esto evita que extensiones del navegador (bloqueadores de anuncios,
// gestores de contraseñas, antivirus, proxies corporativos) que interceptan
// XMLHttpRequest/fetch (como se observó en consola con "ajaxRequestInterceptor")
// dejen el "write stream" de Firestore en un estado colgado, lo cual provoca que
// las escrituras se sigan encolando hasta agotar el límite permitido
// (resource-exhausted: "Write stream exhausted maximum allowed queued writes").
db.settings({
  experimentalForceLongPolling: true
});

const storage = firebase.storage();
const auth = firebase.auth();

export {
  firebase,
  db,
  storage,
  auth
};
